// extracted by mini-css-extract-plugin
export default {"show-on-hover":"scss_show-on-hover__AmXsA","striped":"scss_striped__MJWf8","hoverable":"scss_hoverable__vx2pM","force-open":"scss_force-open__musnW"};